import { CommonState } from './types';
import { MutationTree } from 'vuex';
import { LocationData } from '../../utilities/static-types';

export const mutations: MutationTree<CommonState> = {
  setLocations: (state: CommonState, locations: LocationData[]) => {
    state.locations = locations;
  },
};
